import { useState, type ReactNode } from "react";

export interface FaqItem {
  q: string;
  a: ReactNode;
}

export default function FaqAccordion({ items }: { items: FaqItem[] }) {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <div className="flex flex-col gap-3">
      {items.map((item, i) => {
        const open = openIndex === i;
        return (
          <div key={item.q} className="rounded-2xl border border-border bg-white">
            <button
              type="button"
              onClick={() => setOpenIndex(open ? null : i)}
              aria-expanded={open}
              className="flex min-h-[58px] w-full items-center justify-between gap-4 px-6 py-4 text-left font-bold"
            >
              <span>{item.q}</span>
              <span aria-hidden="true" className="shrink-0 text-xl text-indigo">
                {open ? "−" : "+"}
              </span>
            </button>
            {open && (
              <div className="m-0 px-6 pb-5 text-base leading-relaxed text-muted">{item.a}</div>
            )}
          </div>
        );
      })}
    </div>
  );
}
